import { useAuth0 } from "@auth0/auth0-react";
import styled from "styled-components";

import type { ReauthDetails, SignInRefusal } from "@superblocksteam/shared";

import ErrorComponent from "components/app/Error/ErrorComponent";
import { type SignInErrorReason, signInErrorCopy } from "core/auth/signInError";
import { LOGOUT_URL, SUPPORT_EMAIL_ADDRESS } from "legacy/constants/routes";

const Wrapper = styled.div`
  height: calc(100vh - ${(props) => props.theme.legacy.headerHeight});
  background-color: ${(props) => props.theme.legacy.colors.homepageBackground};
  text-align: center;
  padding-top: calc(${(props) => props.theme.legacy.headerHeight} + 50px);
  .bold-text {
    font-weight: ${(props) => props.theme.legacy.fontWeights[3]};
    font-size: 24px;
  }
  .page-unavailable-img {
    width: 35%;
  }
  .button-position {
    margin: auto;
  }
`;

// A known way back in signs in again with Auth0 hints and returns here; anything else goes through logout.
const RequestUnathorized = ({
  reason,
  reauth,
  signInRefusal,
}: {
  reason?: SignInErrorReason;
  reauth?: ReauthDetails;
  signInRefusal?: SignInRefusal;
}) => {
  const { loginWithRedirect } = useAuth0();
  const copy = signInErrorCopy(
    reason,
    SUPPORT_EMAIL_ADDRESS,
    reauth,
    signInRefusal,
  );
  const { signIn, emphasis } = copy;
  const [before, after] = emphasis
    ? copy.errorMessage.split(emphasis)
    : [copy.errorMessage];
  return (
    <Wrapper>
      <ErrorComponent
        title={copy.title}
        errorMessage={
          emphasis ? (
            <>
              {before}
              <strong>{emphasis}</strong>
              {after}
            </>
          ) : (
            copy.errorMessage
          )
        }
        buttonText={copy.buttonText}
        buttonPath={LOGOUT_URL}
        handleButtonClick={
          signIn &&
          (async () => {
            await loginWithRedirect({
              authorizationParams: signIn,
              appState: {
                returnUrl: `${window.location.pathname}${window.location.search}${window.location.hash}`,
              },
            });
          })
        }
      />
    </Wrapper>
  );
};

export default RequestUnathorized;
